function parseAggregateItem(item) {
  const match = item.match(/(\w+)\s+with\s+(\w+)\s+as\s+(\w+)/);
  if (!match) return {raw: item.trim()};
  return {
    column: match[1],
    func: match[2],
    alias: match[3]
  };
}

function parseApply(applyString) {
  if (!applyString) return null;

  const result = {
    type: null,
    filter: null,
    groupby: [],
    aggregate: []
  };

  const filterRegex = /^filter\((.*?)\)(?:\/(groupby\(\(.*\)\s*,\s*aggregate\((.*?)\)\)))?$/;
  const groupAggRegex = /^groupby\(\((.*?)\),\s*aggregate\((.*?)\)\)$/;
  const aggregateOnlyRegex = /^aggregate\((.*?)\)$/;

  const filterMatch = applyString.match(filterRegex);
  if (filterMatch) {
    result.filter = filterMatch[1].trim();

    if (filterMatch[2] && filterMatch[3]) {
      result.type = "filter-groupby";
      result.groupby = filterMatch[2]
        .match(/groupby\(\((.*?)\)/)[1]
        .split(",")
        .map(s => s.trim());

      result.aggregate = filterMatch[3].split(",").map(parseAggregateItem);
    } else {
      result.type = "filter";
    }

    return result;
  }

  const groupAggMatch = applyString.match(groupAggRegex);
  if (groupAggMatch) {
    result.type = "groupby";
    result.groupby = groupAggMatch[1].split(",").map(s => s.trim());
    result.aggregate = groupAggMatch[2].split(",").map(parseAggregateItem);
    return result;
  }

  const aggOnlyMatch = applyString.match(aggregateOnlyRegex);
  if (aggOnlyMatch) {
    result.type = "aggregate";
    result.aggregate = aggOnlyMatch[1].split(",").map(parseAggregateItem);
    return result;
  }

  return null;
}

export function getMermaidGraphFromODataQuery(mainentityset, encodedQuery) {
  if (!mainentityset || (encodedQuery || "").length === 0) {
    return "";
  }

  const query = decodeURIComponent(encodedQuery);

  const params = new URLSearchParams(query);

  const select = params.get("$select");
  const filter = params.get("$filter");
  const orderby = params.get("$orderby");
  const apply = params.get("$apply");
  const top = params.get("$top");

  let diagram = "graph TD\n";

  diagram += `  ${mainentityset}["${mainentityset}"]\n`;

  if (select) {
    const fields = select.split(",").map(f => f.trim());
    fields.forEach(f => {
      diagram += `  ${mainentityset} --> ${mainentityset}_${f}["select: ${f}"]\n`;
    });
  }

  if (filter) {
    diagram += `  ${mainentityset} --> ${mainentityset}_filter["filter: ${filter}"]\n`;
  }

  if (orderby) {
    diagram += `  ${mainentityset} --> ${mainentityset}_orderby["orderby: ${orderby}"]\n`;
  }

  if (apply) {
    const parsedApply = parseApply(apply);
    if (parsedApply) {
      const applyNode = `${mainentityset}_apply`;
      diagram += `  ${mainentityset} --> ${applyNode}["apply"]\n`;

      if (parsedApply.filter) {
        const filterNode = `${applyNode}_filter`;
        diagram += `  ${applyNode} --> ${filterNode}["filter: ${parsedApply.filter}"]\n`;

        if (parsedApply.type === "filter-groupby") {
          const groupNode = `${filterNode}_group`;
          diagram += `  ${filterNode} --> ${groupNode}["groupby"]\n`;
          parsedApply.groupby.forEach(col => {
            diagram += `  ${groupNode} --> ${groupNode}_${col}["${col}"]\n`;
          });

          const aggNode = `${filterNode}_agg`;
          diagram += `  ${filterNode} --> ${aggNode}["aggregate"]\n`;
          parsedApply.aggregate.forEach(({column, func, alias}) => {
            diagram += `  ${aggNode} --> ${aggNode}_${alias}["${func}(${column}) as ${alias}"]\n`;
          });
        } else if (parsedApply.type === "filter-aggregate") {
          const aggNode = `${filterNode}_agg`;
          diagram += `  ${filterNode} --> ${aggNode}["aggregate"]\n`;
          parsedApply.aggregate.forEach(({column, func, alias}) => {
            diagram += `  ${aggNode} --> ${aggNode}_${alias}["${func}(${column}) as ${alias}"]\n`;
          });
        }
      } else if (parsedApply.type === "groupby") {
        const groupNode = `${applyNode}_group`;
        diagram += `  ${applyNode} --> ${groupNode}["groupby"]\n`;
        parsedApply.groupby.forEach(col => {
          diagram += `  ${groupNode} --> ${groupNode}_${col}["${col}"]\n`;
        });

        const aggNode = `${applyNode}_agg`;
        diagram += `  ${applyNode} --> ${aggNode}["aggregate"]\n`;
        parsedApply.aggregate.forEach(({column, func, alias}) => {
          diagram += `  ${aggNode} --> ${aggNode}_${alias}["${func}(${column}) as ${alias}"]\n`;
        });
      } else if (parsedApply.type === "aggregate") {
        const aggNode = `${applyNode}_agg`;
        diagram += `  ${applyNode} --> ${aggNode}["aggregate"]\n`;
        parsedApply.aggregate.forEach(({column, func, alias}) => {
          diagram += `  ${aggNode} --> ${aggNode}_${alias}["${func}(${column}) as ${alias}"]\n`;
        });
      }
    }
  }

  if (top) {
    diagram += `  ${mainentityset} --> ${mainentityset}_top["top: ${top}"]\n`;
  }

  return diagram;
}
